export const SERVICES = [
  "Devis Electricité",
  "Devis Eau",
  "Devis Gaz",
  "Devis Assurance habitation",
  "Devis déménagement",
  "Visites en vidéo",
  "Accompagnement lors des visites",
  "Rencontre avec un Welcomer",
];
export const PROGRESS_ORDER = [
  "projectCreated",
  "toCall",
  "eligibility",
  "docsMobiPass",
  "toAssign",
  "docsLease",
  "researchStarted",
  "visitScheduled",
  "caseAccepted",
  "leaseFetched",
  "awaitingSignature",
  "signed",
  "submittedToHil",
  "sentToAL",
  "relanceAL",
  "paid",
];

export const CONTRACT_TYPES = [
  { text: "-- CHOISIR --", value: "", disabled: true },
  { text: "Alternant", value: "Alternant" },
  {
    text: "Alternant en recherche d'entreprise",
    value: "Alternant en recherche d'entreprise",
  },
  { text: "Nouvel embauché en CDI", value: "Nouvel embauché en CDI" },
  { text: "Nouvel embauché en CDD", value: "Nouvel embauché en CDD" },
  { text: "En mutation", value: "En mutation" },
  { text: "Intérimaire", value: "Intérimaire" },
  { text: "Autre", value: "Autre" },
];

export const MANDATORY_DOCUMENT_TYPES_FOR_HIL_SUBMISSION = {
  "Aucun document d'identité": { types: ["identity"] },
  "Aucun justificatif de revenus": {
    types: ["wages", "other_incomes", "impots"],
    override: {
      text: "Je certifie que mon client est étudiant ou qu'il ne peut pas fournir de justificatif de revenus",
      property: "income",
    },
  },
  "Aucun avis d'imposition": { types: ["impots"] },
  "Aucun justificatif de domicile": {
    types: ["justif_dom", "justif_dom_other"],
  },
  "Aucun document accord employeur": { types: ["accord_employeur"] },
};

const LOCATAIRE_DOCUMENT_TYPES = [
  "contrat_travail",
  "impots",
  "identity",
  "wages",
  "other_incomes",
  "justif_dom",
  "justif_dom_other",
];
export const PREDEFINED_DOCUMENT_TYPES = [
  {
    pack: "Locataire",
    items: LOCATAIRE_DOCUMENT_TYPES,
  },
  {
    pack: "Garant physique",
    items: [
      "impots",
      "identity",
      "wages",
      "other_incomes",
      "justif_dom",
      "justif_dom_other",
    ],
  },
  {
    pack: "Autre garant",
    items: ["attestation_autre_garant"],
  },
];

export const MANDATORY_DOCUMENT_TYPES_FOR_DISPATCH = {
  "Aucun document accord employeur": ["accord_employeur"],
  "Aucun document lettre de mission": ["lettremission"],
};

export const DOCUMENT_TYPES = [
  {
    value: "identity",
    text: "Pièce d'identité",
    desc: "Au choix : <br><ul><li>Copie recto-verso de la carte d'identité</li><li>Copie des deux pages photo et signature du passeport</li><li>Copie du livret de famille</li><li>Copie de la carte de séjour</li></ul>",
  },
  {
    value: "family_record_book",
    text: "Livret de famille",
    desc: "Copie du livret de famille",
  },
  {
    value: "bail",
    text: "Contrat de bail",
    desc: "Copie intégrale du contrat de bail signé au lieu d'arrivée",
  },
  {
    value: "impots",
    text: "Avis d'imposition",
    desc: "Avis d'imposition le plus récent et celui de l'année précédente (et si rattaché fiscalement aux parents,  ajouter attestation de rattachement fiscal signée + pièce d'identité des parents)",
    count: 2,
  },
  {
    value: "wages",
    text: "Fiches de paye",
    desc: "Vos 3 dernières fiches de paye",
    count: 3,
  },
  {
    value: "other_incomes",
    text: "Autres revenus",
    desc: "Justificatifs de revenu divers",
  },
  {
    value: "justif_dom_other",
    text: "Justificatif de domicile (Autres)",
    desc: "Justificatif de domicile du lieu de départ datant de moins de 3 mois :électricité, gaz, téléphone... (et si hébergé gratuitement, ajouter attestation d'hébergement signé et pièce d'identité)",
  },
  {
    value: "justif_dom",
    text: "Justificatif de domicile",
    desc: "Taxes foncières ou 3 dernières quittances de loyer (et si hébergé gratuitement, ajouter attestation d'hébergement signé + pièce d'identité)",
  },
  {
    value: "contrat_travail",
    text: "Promesse d'embauche & Contrat de travail / Alternance / Mutation",
    desc: "Copie de la promesse d'embauche, du contrat de travail, ou pour le garant une attestation employeur",
  },
  {
    value: "promesse_embauche",
    text: "Promesse d'embauche",
    desc: "Copie de la promesse d'embauche",
  },
  {
    value: "accord_employeur",
    text: "Accord employeur",
    desc: "Accord employeur signé",
    templated: "accord_employeur",
  },
  {
    value: "lettremission",
    text: "Lettre de mission",
    desc: "La lettre de mission signée",
    templated: "lettre_mission",
  },
  {
    value: "eligibilite",
    text: "Test d'éligibilité",
    desc: "Le test d'éligibilité rempli",
    canAdd: false,
  },
  {
    value: "crmission",
    text: "Compte rendu de fin de mission",
    desc: "Compte rendu de fin de mission signé",
    templated: "compte_rendu_mission",
    canAdd: false,
  },
  {
    value: "mobilipass",
    text: "Mobilipass",
    desc: "Mobilipass",
    templated: "dossier_mobilipass",
    canAdd: false,
  },
  {
    value: "full",
    text: "Dossier complet",
    desc: "L'intégralité de votre dossier (ajouté par votre consultante)",
  },
  {
    value: "attestation_autre_garant",
    text: "Attestation (visale, GarantMe, ...)",
    desc: "Copie de votre attestation",
  },
  {
    value: "attestation_temps_transport",
    text: "Attestation temps de transport",
    desc: "Copie de votre attestation",
    templated: "attestation_temps_transport",
  },
  {
    value: "attestation_rattachement_fiscal",
    text: "Attestation de rattachement fiscal",
    desc: "Copie de votre attestation",
    templated: "attestation_rattachement_fiscal",
  },
  {
    value: "attestation_hebergement",
    text: "Attestation d'hébergement",
    desc: "Copie de votre attestation",
    templated: "attestation_hebergement",
  },
  {
    value: "attestation_non_imposition",
    text: "Attestation de non imposition",
    desc: "Copie de votre attestation",
    templated: "attestation_non_imposition",
  },
  {
    value: "facture_prestation",
    text: "Facture prestation",
    desc: "Facture de la prestation",
    folder: "Dossier Mobilipass",
  },
  {
    value: "contrat_prestation_optimise",
    text: "Contrat de prestation Coaching / Optimisé",
    desc: "Contrat de prestation Coaching / Optimisé",
    templated: "contrat_prestation_optimise",
    folder: "Dossier Mobilipass",
  },
  {
    value: "contrat_prestation_premium",
    text: "Contrat de prestation Premium",
    desc: "Contrat de prestation Premium",
    templated: "contrat_prestation_premium",
    folder: "Dossier Mobilipass",
  },
  {
    value: "mandat_recherche",
    text: "Mandat de recherche EXCLUSIF",
    desc: "Mandat de recherche EXCLUSIF",
    templated: "mandat_recherche",
    folder: "Dossier Mobilipass",
  },
  { value: "autres", text: "-- Autres" },
];

export const DOCUMENT_TYPES_TO_EXCLUDE_FOR_ELECTRONIC_SIGNATURE = [
  "mobilipass",
  "crmission",
];

export const PROJECT_STATUS = [
  { value: "en_cours", text: "En cours" },
  { value: "agence_rappel", text: "Agence à rappeler" },
  { value: "agence_repondeur", text: "Agence sur répondeur" },
  { value: "agence_attente", text: "En attente de l'agence" },
  { value: "client_attente", text: "En attente de retours client" },
  {
    value: "denied_too_much_cases",
    text: "Refus - Bien loué / Trop de dossiers",
  },
  { value: "denied_no_match", text: "Refus - Le bien ne correspond pas" },
  {
    value: "denied_no_available",
    text: "Refus - Le bien n'est pas disponible",
  },
  {
    value: "denied_agency",
    text: "Refus - Le dossier a été rejeté par l'agence",
  },
  {
    value: "denied_customer",
    text: "Refus - Le dossier a été rejeté par le client",
  },
];

export const SIGNATURE_STEPS = [
  { value: "onboarding", text: "Accueil" },
  { value: "mobilipass", text: "Nouveau logement trouvé" },
  { value: "mission_done", text: "Fin de mission" },
];

export const SERVICE_WISH = [
  {
    value: "auberge",
    text: "Auberge de l’alternance (étudiants entre deux villes)",
    icon: "warehouse"
  },
  {
    value: "mobilipass",
    text: "Dossier Mobili-PASS (sous conditions d’éligibilité)",
    icon: "assured_workload"
  },
  {
    value: "coaching",
    text: "Service Coaching (étudiants / alternants)",
    icon: "handshake"
  },
  {
    value: "search",
    text: "Service recherche Optimisée (étudiants/ alternants)",
    icon: "search"
  },
  {
    value: "premium-search",
    text: "Service recherche Prémium (salariés / fonctionnaires / indépendants / retraités)",
    icon: "saved_search"
  },
  {
    value: "buyer",
    text: "Service à l’achat (pour tous)",
    icon: "shopping_basket"
  },
];
